// First plannable month, in months ahead of the current one: the planning
// window opens after a 1-month gap (running month + gap), so it starts 2 months
// out (Aug → Oct). Mirrors df_customer_forecast.py's PLANNING_BUFFER_MONTHS = 1.
export const PLANNING_START_OFFSET_MONTHS = 2;

// How far ahead a merchant may manually add a forecast month ("Add month"):
// the running month plus at most this many months into the future.
export const ADD_MONTH_MAX_AHEAD = 3;

type YearMonth = { year: number; month: number };

// Months relative to the current month: negative = already ended (past),
// 0 = current/running month, positive = upcoming.
export function monthsAhead(m: YearMonth, today: Date): number {
  return (m.year - today.getFullYear()) * 12 + (m.month - 1 - today.getMonth());
}

// A month is plannable only from the start of the planning window onward — the
// running month, the gap month and anything past are not (they belong to the
// history / "Verlauf" and may no longer be changed).
export function isInPlanningWindow(m: YearMonth, today: Date): boolean {
  return monthsAhead(m, today) >= PLANNING_START_OFFSET_MONTHS;
}

// Months offered by "Add month": the running month and up to ADD_MONTH_MAX_AHEAD
// months ahead, minus the months that already have a forecast (a forecast may
// not be created twice for the same month). Past months are never offered; the
// current + gap month are allowed (the backend bypasses the deadline rule for
// manually added months).
export function addableMonths(existing: YearMonth[], today: Date): YearMonth[] {
  const taken = new Set(existing.map(m => `${m.year}-${m.month}`));
  const out: YearMonth[] = [];
  for (let i = 0; i <= ADD_MONTH_MAX_AHEAD; i += 1) {
    const d = new Date(today.getFullYear(), today.getMonth() + i, 1);
    const m = { year: d.getFullYear(), month: d.getMonth() + 1 };
    if (!taken.has(`${m.year}-${m.month}`)) out.push(m);
  }
  return out;
}
